import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const VirtualizedGridStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "VirtualizedGrid",
})`
  width: 100%;
  height: 100%;
  position: relative;

  .VirtualizedGrid-FirstRowContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .VirtualizedGrid-FirstColumnContainer {
    display: flex;
    flex-direction: row;
  }

  .VirtualizedGrid-LeftGrid,
  .VirtualizedGrid-CornerGrid,
  .VirtualizedGrid-TopGrid {
    overflow: scroll;
    -ms-overflow-style: none;
    /*prohibit scroll for "frozen" grid containers*/
    scrollbar-width: none;
    display: flex;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .VirtualizedGrid-MainGridInnerContainer {
    position: absolute;
  }

  .VirtualizedGrid-MainGrid {
    display: flex;
  }
`;
